import ScreenService from './screen-service';
import { HTML_TAG_NAME_INPUT } from '../constants/system/html-tag-names';
import FORM_KEY_PREFIX_INDEX from '../constants/system/form-key-prefixes';

export default class FormService {
  public static FORM_KEY_NEW: number = 0;
  public static TEXTAREA_MIN_ROWS_DEFAULT: number = 1;
  public static TEXTAREA_MIN_ROWS_SMALL: number = 2;
  public static TEXTAREA_MIN_ROWS_MEDIUM: number = 5;
  public static TEXTAREA_MAX_ROWS_DEFAULT: number = 1;
  public static TEXTAREA_MAX_ROWS_SMALL: number = 3;
  public static TEXTAREA_MAX_ROWS_MEDIUM: number = 5;
  public static PASSWORD_FIELD_LENGTH_MIN: number = 8;
  public static PASSWORD_FIELD_LENGTH_NORMAL: number = 12;

  private static CLASS_NAME_ERROR: string = 'Mui-error';
  private static FORM_PROP_KEEP_DIRTY_ON_REINITIALIZE: string = 'keepDirtyOnReinitialize';

  public static focusOnFirstFormError(): boolean {
    const tagName: string = HTML_TAG_NAME_INPUT;
    const className: string = this.CLASS_NAME_ERROR;

    const elementList: HTMLCollectionOf<HTMLElement> = ScreenService.getElementsByTagName(tagName);

    for (let elementIndex: number = 0; elementIndex < Object.values(elementList).length; elementIndex++) {
      const element: HTMLElement = Object.values(elementList)[elementIndex];

      if (element && element.parentElement && element.parentElement.classList.contains(className)) {
        element.focus();
        break;
      }
    }

    return true;
  }

  public static getIndexedFormFieldKey(fieldId: number): string {
    return `${FORM_KEY_PREFIX_INDEX}-${fieldId}`;
  }

  public static extractIndexedFormFieldKey(fieldKey: string | number): string | null {
    return fieldKey && fieldKey.toString() ? fieldKey.toString().replace(`${FORM_KEY_PREFIX_INDEX}-`, '') : null;
  }

  public static forceResetForm(resetForm: Function, formProps: FormProps): void {
    if (resetForm && formProps) {
      formProps.setConfig(this.FORM_PROP_KEEP_DIRTY_ON_REINITIALIZE, false);
      resetForm();
      formProps.setConfig(this.FORM_PROP_KEEP_DIRTY_ON_REINITIALIZE, true);
    }
  }

  public static resetFormServerErrors(form: FormState, fieldName: string): void {
    const registeredFields: string[] = form ? form.getRegisteredFields() : [];

    if (registeredFields && registeredFields.length) {
      for (let fieldIndex: number = 0; fieldIndex < registeredFields.length; fieldIndex++) {
        const registeredFieldName: string = registeredFields[fieldIndex];

        if (registeredFieldName === fieldName) {
          const fieldState: FormFieldState = form.getFieldState(fieldName);

          if (fieldState.error || fieldState.submitError) {
            form.resetFieldState(fieldName);
          }
        }
      }
    }
  }

  public static onSubmitFormEmptyAction(): boolean {
    return true;
  }
}
